var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"user-tab-notification"},[_c('notifactions')],1)}
var staticRenderFns = []

export { render, staticRenderFns }